import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sa-lmo-frac-home-directions',
  styleUrls: ['./lmo-frac-home-directions.component.scss'],
  templateUrl: './lmo-frac-home-directions.component.html',
})
export class LmoFracHomeDirectionsComponent implements OnInit {
  @Input() public localStorageKey: string;
  @Input() public isLoading = false;
  @Input() public frac: any;

  constructor(private snackBar: MatSnackBar) {}

  public ngOnInit(): void {}

  public copyDirection(direction: string | null): void {
    if (!direction) {
      this.snackBar.open('No directions available to copy.', '', {
        duration: 2000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
      });
      return;
    }

    navigator.clipboard
      .writeText(direction)
      .then(() => {
        this.snackBar.open('Copied to clipboard!', '', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      })
      .catch((err) => {
        console.error('Failed to copy direction: ', err);
        this.snackBar.open('Failed to copy to clipboard. Please try again.', '', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      });
  }
}
